import React from "react";
import { useI18n } from "../i18n";
import { MEDIA } from "../constants";

export default function Gallery() {
  const { t } = useI18n();

  return (
    <section
      id="gallery"
      className="relative py-24 md:py-32 border-t border-[#2d2622] bg-[#0a0908]"
      data-testid="gallery-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-6">
              <div className="divider-gold" />
              <span className="overline">{t.gallery.overline}</span>
            </div>
            <h2
              className="font-serif-display text-4xl sm:text-5xl md:text-6xl font-light leading-tight text-[#f4f0eb]"
              data-testid="gallery-title"
            >
              {t.gallery.title}
            </h2>
          </div>
          <p className="text-[#a39e97] md:max-w-sm md:text-right text-base leading-relaxed">
            {t.gallery.subtitle}
          </p>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-12 gap-3 md:gap-4 auto-rows-[120px] md:auto-rows-[180px]">
          <GalleryTile
            src={MEDIA.hero_interior}
            className="col-span-12 md:col-span-8 row-span-3"
            alt="Interior íntimo con velas"
            id="interior-main"
          />
          <GalleryTile
            src={MEDIA.gallery_canelon}
            className="col-span-6 md:col-span-4 row-span-2"
            alt="Canelón en cacerola"
            id="canelon"
          />
          <GalleryTile
            src={MEDIA.gallery_ravioles}
            className="col-span-6 md:col-span-4 row-span-1"
            alt="Ravioles con vino"
            id="ravioles"
          />
          <GalleryTile
            src={MEDIA.gallery_plate_main}
            className="col-span-6 md:col-span-4 row-span-2"
            alt="Plato de autor"
            id="main-plate"
          />
          <GalleryTile
            src={MEDIA.gallery_interior}
            className="col-span-6 md:col-span-4 row-span-2"
            alt="Lounge con sillones de terciopelo"
            id="lounge"
          />
          <GalleryTile
            src={MEDIA.menu_cocktail_1}
            className="col-span-12 md:col-span-4 row-span-2"
            alt="Trago de autor"
            id="cocktail"
          />
        </div>
      </div>
    </section>
  );
}

function GalleryTile({ src, alt, className, id }) {
  return (
    <figure
      className={`relative overflow-hidden group ${className}`}
      data-testid={`gallery-tile-${id}`}
    >
      <img
        src={src}
        alt={alt}
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0d0c0b]/60 via-transparent to-transparent opacity-80 group-hover:opacity-60 transition-opacity duration-500" />
    </figure>
  );
}
